import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import { Tooltip } from 'react-tooltip';
import { getAllSharedVoicemail } from '../../apiclients/streamsapi_bridge';
import { getAssocCFDataByEntityIdNodeType } from '../../components/topviews/HuntGroups';
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import PopupLoaderNew from '../popups/PopupLoaderNew';
import RemoveSharedVM from '../popups/sharevm/RemoveSharedVM';
import PopupLoader from '../popups/PopupLoader';
import AddNewVMBox from '../popups/callflow/AddNewVmailBox';

const VmLandingpage = () => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(true);
    const [internalError, setInternalError] = useState(false);
    const [sharedVMList, setsharedVMList] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [vmBoxDetails, setVmBoxDetails] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    const [addVM, setAddVM] = useState(false);
    const toggleAddVM = () => setAddVM(!addVM);
    const [deleteVM, setDeleteVM] = useState(false);
    const dtogglePopup = () => setDeleteVM(!deleteVM);
    const [selectedVmId, setSelectedVmId] = useState();
    const deleteVMRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [assocCallFlows, setAssocCallFlows] = useState([]);

    function handleClick() {
        deleteVMRef.current.click();
    }

    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef);

    useEffect(() => {
        fetchAllVM();
    }, []);

    async function fetchAllVM() {
        try {
            setInternalError(false);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getAllSharedVoicemail(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("VM data :::::::::: " + JSON.stringify(rawData));
            setsharedVMList(rawData?.all_voicemails ?? []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

        } catch (error) {
            console.error("Error fetching VM data:", error);
            setInternalError(true);
            setIsloading(false);
        }
    }

    useEffect(() => {
        let processedRows = [];
        sharedVMList.map((vm) => {
            processedRows.push({
                vmInfo: vm,
                name: vm.name + "",
                extension: vm.extension + "",
                pin: vm.vmail_pin + "",
                vmtype: vm.vmtype === 1 ? "Shared" : "Personal",
                delete: (
                    <>
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deleteThisVM(e, vm.vmid)}>
                                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                            </div>
                        </div>
                    </>
                ),
            });
        });
        setFilteredRows(processedRows);
        setVmBoxDetails(processedRows);
        setDataLoaded(true);
    }, [sharedVMList]);

    async function deleteThisVM(evntData, vmId) {
        evntData.preventDefault();
        evntData.stopPropagation();
        console.log("Delete VM with ID:", vmId);
        // Implement delete functionality here
        // You can add a delete popup similar to Fax Groups
        // fetching the associated CF information
        let associatedCF = await getAssocCFDataByEntityIdNodeType(JSON.parse(sessionStorage.getItem("admin_session")).siteid, vmId, 8);
        setAssocCallFlows(associatedCF?.associated_callflows ?? []);
        // setassocLunaHops(associatedCF?.associated_luna_hops ?? []);
        // setacdOverFlow(associatedCF?.isExistsInACDSettings ?? []);
        setSelectedVmId(vmId);
        setDeleteVM(true);
    }

    const actionData = {
        columns: [
            { label: 'Name', field: 'name', sort: true },
            { label: 'Extension', field: 'extension', sort: true },
            { label: 'Pin', field: 'pin', sort: true },
            // { label: 'Type', field: 'vmtype', sort: true },
            { label: 'Remove', field: 'delete', sort: false },
        ],
        rows: filteredRows,
    };

    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(vmBoxDetails, searchValue, UIConstant.VM_LANDINGPAGE);
        setFilteredRows(filtered);
    };

    const showThisInfo = (tdata) => {
        navigate("/vmsettings", {
            state: tdata.vmInfo,
        });
    };

    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={129}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            {t("vmBox")}
                                        </h5>
                                    </div>
                                    <div className="mt-3">
                                        <div className="vmBoxDatatable">
                                            <div className="actionbar">
                                                {/* Add button can be added here if needed */}
                                                {/* <MDBBtn className="btn_adjust" onClick={toggleOpen}>
                                                    <MDBIcon fas icon="plus" className="me-2" /> Add Voicemail
                                                </MDBBtn> */}
                                                <div>
                                                    <MDBBtn onClick={toggleAddVM}>
                                                        <MDBIcon fas icon="plus" className="me-2" /> Add Shared VM
                                                    </MDBBtn>
                                                </div>
                                            </div>
                                            <div className='mb-2 mt-0 position-relative w-auto'>
                                                <MDBInput
                                                    label="Search"
                                                    value={searchValue}
                                                    ref={searchRef}
                                                    onChange={(e) => handleManualSearch(e.target.value)}
                                                />
                                                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                            </div>
                                            <div className="input-group rounded w-100 dblock huntDataTable">
                                            <MDBDatatable
                                                className="actioncolumn"
                                                // multi
                                                // selectable
                                                fixedHeader
                                                sortField="Name"
                                                hover
                                                data={actionData}
                                                entries={50}
                                                onRowClick={(e) => showThisInfo(e)}
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>
                    }
                />

                {addVM && (
                    <PopupLoader
                        size="lg"
                        title="Add Shared VM"
                        content={
                            <AddNewVMBox
                                onClose={toggleAddVM}
                                source="vmlanding"
                            />
                        }
                        onShow={setAddVM}
                        onClose={toggleAddVM}
                    />
                )}

                {deleteVM && (
                    <PopupLoaderNew
                        title={"Remove Voicemail Box"}
                        content={
                            <RemoveSharedVM
                                vmId={selectedVmId}
                                onClose={dtogglePopup}
                                ref={deleteVMRef}
                                setIsloading={setisLoading}
                                assocCFData={assocCallFlows}
                            />
                        }
                        onShow={setDeleteVM}
                        onClose={dtogglePopup}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={assocCallFlows.length == 0 ? 4 : 10}
                        hideClose={assocCallFlows.length == 0 ? false : true}
                    />
                )}

                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>

                {internalError && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setInternalError(false)}
                    >
                        Internal Server Error
                    </MDBAlert>
                )}

                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
            </>
        </React.Fragment>
    );
};

export default VmLandingpage;